import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login.vue'
import ExtAccount from '@/views/ExtAccount.vue'
import ManageLayout from '@/layouts/ManageLayout.vue'
import NewContents from '@/views/Contents/NewContents.vue'
import MyContents from '@/views/Contents/MyContents.vue'
import ImageManager from '@/views/ImageManager.vue'
import Group from '@/views/Group.vue'
import UserSetting from '@/views/UserSetting.vue'
import Log from '@/views/Log.vue'
import TestEmailPreset from '@/views/TestEmailPreset.vue'
import ContentEdit from '@/views/Content/Edit.vue'
import ContentPreview from '@/views/Content/Preview.vue'
import Capture from '@/views/Capture.vue'
import NotFound from '@/views/NotFound.vue'
import * as utilToken from '@/utils/Token'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:mpDomain/:siteId/login',
    name: 'login',
    component: Login,
    meta: {
      isPublic: true
    },
  },
  {
    path: '/:mpDomain/:siteId/ext_account',
    name: 'extAccount',
    component: ExtAccount,
    meta: {
      isPublic: true
    },
  },
  {
    path: '/:mpDomain/:siteId/',
    component: ManageLayout,
    children: [
      {
        path: '',
        redirect: '/:mpDomain/:siteId/content/list', // メーリング一覧へ
      },
      {
        path: '/:mpDomain/:siteId/content/new',
        name: 'contentNew',
        component: NewContents,
      },
      {
        path: '/:mpDomain/:siteId/content/list',
        name: 'contentList',
        component: MyContents,
      },
      {
        path: '/:mpDomain/:siteId/content/group',
        name: 'contentGroup',
        component: Group,
        props: {
          kind: 'content'
        }
      },
      {
        path: '/:mpDomain/:siteId/image/list',
        name: 'imageList',
        component: ImageManager,
        props: {
          isLogo: false,
        }
      },
      {
        path: '/:mpDomain/:siteId/image/logo',
        name: 'imageLogo',
        component: ImageManager,
        props: {
          isLogo: true,
        }
      },
      {
        path: '/:mpDomain/:siteId/image/group',
        name: 'imageGroup',
        component: Group,
        props: {
          kind: 'image'
        }
      },
      {
        path: '/:mpDomain/:siteId/user_setting',
        name: 'userSetting',
        component: UserSetting,
      },
      {
        path: '/:mpDomain/:siteId/log/list',
        name: 'log',
        component: Log,
      },
      {
        path: '/:mpDomain/:siteId/test_email_preset',
        name: 'testEmailPreset',
        component: TestEmailPreset,
      },
    ],
  },
  {
    path: '/:mpDomain/:siteId/content/edit/:id(\\d+)',
    name: 'contentEdit',
    component: ContentEdit,
  },
  {
    path: '/:mpDomain/:siteId/content/preview/:id(\\d+)',
    name: 'contentPreview',
    component: ContentPreview,
    props: {
      isNew: false
    },
  },
  {
    path: '/:mpDomain/:siteId/content_new/preview/:contentType(layout|design|custom)/:id(\\d+)',
    name: 'contentNewPreview',
    component: ContentPreview,
    props: {
      isNew: true
    },
  },
  {
    path: '/content/capture/:type(my|layout|design|custom)/:id(\\d+)/:jobId/:capturePassword',
    name: 'capture',
    meta: {
      isPublic: true
    },
    component: Capture,
  },
  {
    path: '*',
    name: 'notFound',
    component: NotFound,
    meta: {
      isPublic: true
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name === 'notFound') {
    next()
  } else if (to.matched.some(route => !route.meta.isPublic) && !utilToken.get(to.params)) {
    if (to.params.mpDomain && to.params.siteId) {
      next({
        path: `/${to.params.mpDomain}/${to.params.siteId}/login`,
        query: { redirect: to.fullPath }
      })
    } else {
      next({
        path: '/notFound',
      })
    }
  } else {
    next()
  }
})
export default router
